var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container page-layout",class:{ fixed: _vm.isFixed, 'full-height': _vm.hasFullHeight }},[_c('header',{staticClass:"mt-4 pl-0 ml-0"},[_vm._t("header")],2),_c('main',[_vm._t("main")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }